var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title:
          _vm.natural_entity_id === null
            ? "Cadastrar Pessoa Natural"
            : "Editar Pessoa Natural"
      }
    },
    [
      _c(
        "vs-tabs",
        {
          attrs: { color: _vm.colorx },
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Dados Básicos" } },
            [
              _c("NaturalEntity", {
                attrs: {
                  services: _vm.services,
                  naturalEntityId: _vm.natural_entity_id
                }
              })
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Endereço", disabled: _vm.isTabEnabled } },
            [
              _c("Address", {
                attrs: {
                  services: _vm.services,
                  addressTypeList: _vm.addressTypeList
                }
              })
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Telefone", disabled: _vm.isTabEnabled } },
            [_c("Phone", { attrs: { services: _vm.services } })],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Email", disabled: _vm.isTabEnabled } },
            [
              _c("Email", {
                attrs: {
                  services: _vm.services,
                  emailTypeList: _vm.emailTypeList
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }